var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [_c("router-view")], 1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33ecc84c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rstool/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ecc84c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/rstool/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/App.vue
// module id = 367
// module chunks = 20